import { type QueryHookOptions, useQuery } from '@apollo/client'
import {
  getFeaturesPermissions,
  getOldFeaturesPermissions,
  getUserProps
} from 'utils/features-control'
import { userBasicInfosQuery } from 'api/queries'
import type { User } from 'api/data.types'
import { useMemo } from 'react'

export const useUserInfo = (options?: QueryHookOptions) => {
  const { data, ...rest } = useQuery<{ me?: User }>(
    userBasicInfosQuery,
    options
  )
  const user = useMemo(() => {
    const me = data?.me || {}
    return {
      ...me,
      ...getUserProps(me),
      ...getOldFeaturesPermissions(me),
      ...getFeaturesPermissions(me)
    }
  }, [data?.me])

  return {
    user,
    ...rest
  }
}
